import headerImg from 'images/home/header-home-biolitoral.png'
import headerImg2 from 'images/home/header-home-biolitoral-2.png'

// HOME IMAGES
import entriesImg from 'images/home/bt-entries-square.png'
import clasificationsImg from 'images/home/bt-clasifications-square.png'
import containersImg from 'images/home/bt-containers.png'
import statsImg from 'images/home/bt-stats.png'

// APP METADATA
export const appName = 'Biolitoral Agricultores';
export const primaryColor = '#fdc11e';
export const appBar = {
  background: primaryColor,
}
export const images = {
  logo: '',
  header: headerImg,
  header2: headerImg2,
  entries: entriesImg,
  clasifications: clasificationsImg,
  container: containersImg,
  stats: statsImg,
}

export const headerStyles = {
  backgroundSize: '20%',
  backgroundRepeat: 'no-repeat',
}

// COMMON STYLES
export const filters = {
  background: primaryColor,
}
export const productName = {
  fontSize: 16,
  fontWeight: 500,
  color: primaryColor,
}
export const btSamplings = {
  position: 'relative',
  padding: 5,
  fontSize: 16,
  backgroundColor: primaryColor,
  color: 'white',
  borderRadius: 3,
  textAlign: 'center',
  cursor: 'pointer',
}




// WEBPACK FOOTER //
// ./src/Styles.js